import markerintegrate from "../../../../assets/images/integrations/screens/markerio/marker7.png";
import toggleintegrations from "../../../../assets/images/docs/integrations/toggleintegrations.png";
import cogicon from "../../../../assets/images/docs/integrations/cogicon.png";
import * as React from 'react';
export default {
  markerintegrate,
  toggleintegrations,
  cogicon,
  React
};